module.exports = __webpack_public_path__ + "img/146.3.1308ff61.png";